import { client } from './portal';

// GET /public/profiles — this account's saved profiles, each with a documentTypes[] coverage list
// (e.g. ['cv','passport']) so the UI can show "CV on file" without a second round trip. At most one
// row now (candidate-portal-single-profile-avatar) — callers should treat this as profiles[0].
export async function fetchProfiles() {
  const { data } = await client.get('/public/profiles');
  return data.profiles;
}

// GET /public/profiles/:id — single profile detail, same fields as the list minus documentTypes,
// plus a `documents` array ([{type, pageCount, originalName, uploadedAt}]) for the Dashboard's
// "Documents on file" list.
export async function fetchProfile(id) {
  const { data } = await client.get(`/public/profiles/${id}`);
  return data.profile;
}

// PUT /public/profiles/:id — partial update, e.g. { name, phone, skills, isDefault, openToOtherRoles }.
export async function updateProfile(id, updates) {
  const { data } = await client.put(`/public/profiles/${id}`, updates);
  return data.profile;
}

// Same bearer-token-needs-a-blob reasoning as api/portal.js's fetchDashboardDocumentPreviewUrl — GET
// /profiles/:id/avatar is requirePortalAuth-gated, so a plain <img src> can't carry the token. Caller
// must URL.revokeObjectURL when done (the Avatar component does this on unmount/prop change).
export async function fetchProfileAvatarUrl(id) {
  const { data } = await client.get(`/public/profiles/${id}/avatar`, { responseType: 'blob' });
  return URL.createObjectURL(data);
}

// POST /public/profiles/:id/avatar (multipart: file). Backend re-encodes + validates it's a real
// JPG/PNG/WEBP image (profiles.ts) — this is just the upload call.
export async function uploadProfileAvatar(id, file) {
  const form = new FormData();
  form.append('file', file);
  const { data } = await client.post(`/public/profiles/${id}/avatar`, form);
  return data; // { ok: true }
}
